import React, { ReactNode } from "react"
import { Col, Row } from "react-bootstrap"
import FormatDate from "../../../../formatters/FormatDate"
import FormatTime from "../../../../formatters/FormatTime"

interface BreakpointNumbers {
  xs?: number
  sm?: number
  md?: number
  lg?: number
  xl?: number
}

interface CardRowProps {
  title: string
  value?: any
  date?: boolean
  time?: boolean
  bool?: boolean
  titleBreakpoints?: BreakpointNumbers
  valueBreakpoints?: BreakpointNumbers
  children?: ReactNode
}
export default function CardRow(props: CardRowProps) {
  const { title, value, date, time, bool, titleBreakpoints: titleBr, valueBreakpoints: valueBr, children } = props
  const titleXs = titleBr?.xs || 6
  const titleMd = titleBr?.md || 4
  const valueXs = valueBr?.xs || 6
  const valueMd = valueBr?.md || 8
  return (
    <Row className="p-1">
      <Col xs={titleXs} sm={titleBr?.sm} md={titleMd} lg={titleBr?.lg} xl={titleBr?.xl} className="test-property">{title}</Col>
      <Col xs={valueXs} sm={valueBr?.sm} md={valueMd} lg={valueBr?.lg} xl={valueBr?.xl} className="status-text">
        {date ? FormatDate(value) : time ? FormatTime(value) : bool ? (value ? "Yes" : "No") : value}
        {children}
      </Col>
    </Row>
  )
}
